import { Observable } from 'rxjs';

import UserApi from 'entities/user/api';

import { SUBMIT } from './constants';
import { submitSuccessAction, submitFailedAction } from './actions';

const submit = (action$) =>
  action$.ofType(SUBMIT).exhaustMap(({ token, password }) =>
    UserApi.resetPassword(token, password)
      .mergeMap(() => [submitSuccessAction()])
      .catch((e) => Observable.of(submitFailedAction(e, 'submitFailed')))
  );

export default [submit];
